import axios from 'axios'
import _ from 'lodash'

// state
const state = {
	isLoading: false,
    //passwordErr: false,
    //confirmPasswordErr: false,
    //canSavePassword: false,
    showTokenExpiredMessage: false,
    showPasswordSavedMessage: false,
    userId: '',
}

const getters = {

}


// mutations
const mutations = {
	TOGGLE_BOOLEAN_STATE(state, {key, bool}){
		eval('state.' + key + ' = bool');
	},

	SET_MESSAGE (state, {key, message}){
		eval('state.' + key + ' = message');
	},

	SET_VARIABLE (state, {key, value}){
		eval('state.' + key + ' = value');
	},
}

// actions
const actions = {
	setVariable({commit}, {key, value}){
		commit('SET_VARIABLE', {key: key, value: value});
	},

	setBoolean({commit}, {key, bool}){
		commit('TOGGLE_BOOLEAN_STATE', {key: key, bool: bool});
	},

	checkToken({commit, dispatch, rootState}, data){
		var url = rootState.auth.l+'password-reset';

		// pass it to api and check to make sure token exist & is not expired
        axios.post(url, data)
        .then(response => {
        	if(response.data.status === '404'){
				commit('TOGGLE_BOOLEAN_STATE', {key: 'showTokenExpiredMessage', bool: true});
        	} else if(response.data.status === '200'){
        		commit('SET_MESSAGE', {key: 'userId', message: response.data.user_id});
        	}
        })   
        .catch((error) => {
        	console.log(error);
            // if(error.response.status === 404){
            // 	console.log("404");
            // }
        });
	},

	savePassword({commit, state, rootState}, password){
		var url = rootState.auth.l+'save-password';
		var data = {
			id: state.userId,
			password: password.password,
			token: password.token
		}
		// pass it to api and check to make sure token exist & is not expired
        axios.post(url, data)
        .then(response => {
        	if(response.status === 200){
				//commit('TOGGLE_BOOLEAN_STATE', {key: 'isLoading', bool: false});

				// delay
				setTimeout(function(){ 
					commit('SET_VARIABLE', {key: 'isLoading', value: false});            	
					window.location.href = '/login';
				}, 3000);
        	}
        })   
        .catch((error) => {
        	console.log(error);
            // if(error.response.status === 404){
            // 	console.log("404");
            // }
        });
	}
}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
	actions
}